import { createContext } from 'react';

type PermissionErrorModalContextType = {
  showPermissionError: (message?: string) => void;
};

const PermissionErrorModalContext = createContext<PermissionErrorModalContextType | undefined>(
  undefined,
);

export default PermissionErrorModalContext;
